export default [
  {
    before: '<i class="material-icons">description</i>',
    title: 'Orders',
    to: {
      name: 'order.index',
    }
  },
  {
    before: '<i class="material-icons">help</i>',
    title: 'FAQ',
    to: {
      name: 'faq.index',
    }
  },
];
